import React, { Component } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import moment from "moment";
import {
  IProfileProps,
  IProfileState,
} from "../../interfaces/profile.interface";
import { IRootState } from "../../interfaces";
import { getProfileRequest, updateProfileRequest } from "../../action";
import { logger } from "../../helper/Logger";
import { profileValidator } from "../../helper/validator/profile.validator";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AlertMessage from "./AlertMessage";

class Profile extends Component<IProfileProps, IProfileState> {
  constructor(props: IProfileProps) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      birthDay: "",
      gender: "",
      showPopup: false,
      errors: {},
      showAlert: false,
      loading: false,
      imageFileName: "",
      imageFile: "",
    };
  }
  componentDidMount = () => {
    this.getProfileData();
  };
  componentDidUpdate = (prevProps: IProfileProps) => {
    const { profileReducer } = this.props;
    if (
      prevProps.profileReducer &&
      profileReducer &&
      profileReducer.isLoading !== prevProps.profileReducer.isLoading
    ) {
      this.getProfileData();
    }
  };

  getProfileData = () => {
    const { profileReducer } = this.props;

    if (
      profileReducer &&
      profileReducer.profileInfo &&
      Object.entries(profileReducer.profileInfo).length
    ) {
      const { profileInfo } = profileReducer;
      logger(profileInfo);

      // debugger;

      const profileData: any = profileInfo;
      let {
        firstName,
        lastName,
        email,
        gender,
        birthDay,
        profileCompleted,
        showPopup,
      } = profileData;
      this.setState({
        showPopup,
        firstName,
        lastName,
        email,
        gender,
        birthDay: birthDay ? new Date(birthDay) : "",
        showAlert: !profileCompleted,
      });
      logger(profileCompleted);
      logger(this.state.loading);
      logger("logger in did update");
      if (profileCompleted !== undefined) {
        this.setState({
          loading: false,
        });
      }
    }
  };
  handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    if (name === "email") {
      return;
    }
    this.setState({
      ...this.state,
      [name]: value,
      errors: {
        ...this.state.errors,
        [name]: "",
      },
    });
  };
  // To handle date change
  handleDateChange = (date: Date) => {
    this.setState({
      birthDay: date,
    });
  };
  onGenderChange = (gender: string) => {
    this.setState({
      gender,
    });
  };

  // submitting profile
  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { email, firstName, lastName, gender, birthDay } = this.state;
    const data = {
      email,
      firstName,
      lastName,
    };
    // To validate form fields
    const { isValid, errors } = profileValidator(data);

    if (isValid) {
      const { updateProfileInfo } = this.props;
      if (updateProfileInfo) {
        this.setState({
          loading: true,
        });
        updateProfileInfo({
          ...data,
          lastName,
          gender,
          birthDay: birthDay ? birthDay.toISOString() : "",
        });
      }
    } else {
      this.setState({ errors });
      return;
    }
  };
  handleAlertClose = () => {
    this.setState({
      showAlert: false,
    });
    const { email, firstName, lastName, gender, birthDay } = this.state;
    const { updateProfileInfo } = this.props;
    if (updateProfileInfo) {
      this.setState({
        loading: true,
      });
      updateProfileInfo({
        email,
        firstName,
        lastName,
        gender,
        birthDay,
        showPopup: false,
      });
    }
  };
  handleDateChangeRaw = (e: any) => {
    e.preventDefault();
  };

  render() {
    const {
      firstName,
      lastName,
      email,
      birthDay,
      gender,
      errors,
      showAlert,
      loading,
      showPopup,
    } = this.state;
    const maxDate = new Date(
      moment().subtract(13, "years").format("YYYY-MM-DD")
    );
    return (
      <div className="main-section">
        <div className="col-lg-12 col-md-12">
          <div className="profile-form">
            {!loading && showPopup ? (
              <AlertMessage
                handleClose={this.handleAlertClose}
                show={showAlert}
              />
            ) : null}

            <Form className="row" onSubmit={this.handleSubmit}>
              <div className="col-md-12">
                <div className="d-flex align-items-center">
                  <h4 className="mb-5">
                    Profile <span className="border-heading" />
                  </h4>
                  <button className="btn btn-submit mb-5 ml-auto" type="submit">
                    {loading ? "Please wait .." : " Save Changes"}
                  </button>
                </div>
              </div>
              <Form.Group className="col-lg-3 col-md-6">
                <InputGroup>
                  <input
                    type={"text"}
                    name={"firstName"}
                    value={firstName}
                    className={"form-control floating-input"}
                    placeholder=" "
                    onChange={this.handleChange}
                  />
                  <Form.Label
                    className={`floating-label ${firstName ? "top-label" : ""}`}
                  >
                    First Name<span className="mandatory">*</span>
                  </Form.Label>
                  <div className={"text-danger error-text-password"}>
                    {errors && errors.firstName}
                  </div>
                </InputGroup>
              </Form.Group>
              <Form.Group className="col-lg-3 col-md-6">
                <InputGroup>
                  <input
                    type={"text"}
                    name={"lastName"}
                    value={lastName}
                    className={"form-control floating-input"}
                    placeholder=" "
                    onChange={this.handleChange}
                  />
                  <Form.Label
                    className={`floating-label ${lastName ? "top-label" : ""}`}
                  >
                    Last Name
                  </Form.Label>
                  <div className={"text-danger error-text-password"}>
                    {errors && errors.lastName}
                  </div>
                </InputGroup>
              </Form.Group>

              <Form.Group className="col-lg-6 col-md-12">
                <InputGroup>
                  <input
                    type={"text"}
                    name={"email"}
                    value={email}
                    className={"form-control floating-input"}
                    placeholder=" "
                    onChange={this.handleChange}
                    disabled
                  />
                  <Form.Label
                    className={`floating-label ${email ? "top-label" : ""}`}
                  >
                    Email Address<span className="mandatory">*</span>
                  </Form.Label>
                  <div className={"text-danger error-text"}>
                    {errors && errors.email}
                  </div>
                </InputGroup>
              </Form.Group>
              <Form.Group className="col-lg-6 col-md-12">
                <Form.Label className="simple-label">Gender</Form.Label>
                <Form.Check
                  type={"radio"}
                  label={"Male"}
                  name={"gender"}
                  id={"male"}
                  value={"male"}
                  checked={gender === "male"}
                  inline
                  onChange={() => this.onGenderChange("male")}
                />
                <Form.Check
                  type={"radio"}
                  label={"Female"}
                  name={"gender"}
                  id={"female"}
                  value={"female"}
                  checked={gender === "female"}
                  inline
                  onChange={() => this.onGenderChange("female")}
                />
              </Form.Group>
              <Form.Group className="col-lg-6 col-md-6">
                <Form.Label className="simple-label">Date of birth</Form.Label>
                <ReactDatePicker
                  placeholderText="Select a date of birth"
                  onChange={this.handleDateChange}
                  selected={birthDay}
                  maxDate={maxDate}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
                <span className="calender-icon">
                  <i className="far fa-calendar-alt"></i>
                </span>
                {birthDay ? (
                  <span
                    className="calender-crossicon cursor-pointer"
                    onClick={() =>
                      this.setState({
                        birthDay: "",
                      })
                    }
                  >
                    &times;
                  </span>
                ) : null}
              </Form.Group>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  profileReducer: state.profileReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getProfileInfo: () => {
      dispatch(getProfileRequest());
    },
    updateProfileInfo: (data: any) => {
      dispatch(updateProfileRequest(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
